module.exports = __webpack_public_path__ + "static/media/feedback-sad.f1a8e6e1.png";